module.exports = __webpack_public_path__ + "img/email.08c93244.png";